import { inject, Injectable, Signal, signal } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private currentLabel = signal<string | null>(null);
  private previousFocus: HTMLElement | null = null;
  private router = inject(Router);

  constructor() {
    this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => this.close());
  }

  close(): void {
    if (!this.currentLabel()) {
      return;
    }
    const previousFocus = this.previousFocus;
    this.currentLabel.set(null);
    this.previousFocus = null;
    requestAnimationFrame(() => {
      if (!this.currentLabel() && previousFocus?.isConnected) {
        previousFocus.focus();
      }
    });
  }

  dismiss(): void {
    this.close();
  }

  get(): Signal<string | null> {
    return this.currentLabel.asReadonly();
  }

  open(label: string): void {
    if (!this.currentLabel()) {
      this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    }
    this.currentLabel.set(label || 'Cargando...');
  }
}
